import { makeStyles } from '@lifeomic/chroma-react/styles';
import { Text } from '@lifeomic/chroma-react/components/Text';
import React from 'react';

const useStyles = makeStyles(() => ({
  capitalize: {
    textTransform: 'capitalize',
  },
}));

interface SequenceDetailsValueProps {
  value?: string;
  preserveCase?: boolean;
}

export const SequenceDetailsValue: React.FC<SequenceDetailsValueProps> = ({
  value,
  preserveCase,
  ...rootProps
}) => {
  const classes = useStyles({});

  return (
    <Text
      className={!preserveCase ? classes.capitalize : undefined}
      size="subbody"
      {...rootProps}
    >
      {value}
    </Text>
  );
};
